module.exports = __webpack_public_path__ + "Roboto-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.eot
// module id = 27
// module chunks = 0